import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader';
import CONSTANTS from '../../constants';

const { GCPCERTS_API_URL } = CONSTANTS;

export type GcpCertDetailsUpdate = {
  gcpCertID: string;
  action: 'UPDATE_DETAILS';
  details: Record<string, unknown>;
};

const updateCertDetails = async (payload: GcpCertDetailsUpdate): Promise<any> => {
  const response = await fetchWithAuthorizationHeader(`${GCPCERTS_API_URL}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      action: 'UPDATE_DETAILS',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(`Failed to update certificate: ${message}`);
  }

  return response.json();
};

export default updateCertDetails;
